import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DialogModule} from '../../../../../common/dialog/dialog.module';
import {PartnerSimilarPartnerViewDialogComponent} from './partner-similar-partner-view-dialog.component';
import {ActionDefaultModule} from '../../../../../core/component/action-default/action-default.module';
import {LoadingModule} from '../../../../../../components/common/loading/loading.module';
import {ErrorTextModule} from '../../../../../core/component/error-text/error-text.module';
import {ItemModule} from '../../../../../core/component/item/item.module';
import {SummaryFieldModule} from '../../../../../core/component/summary-field/summary-field.module';
import {
    LovValueSummaryFieldModule
} from '../../../../../common/lov/lov-value/api/component/lov-value-summary-field/lov-value-summary-field.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {
    AdditionalPropertyLabelModule
} from '../../../../../common/additional-property/component/additional-property-label/additional-property-label.module';
import {AgeLabelModule} from '../../../../../person/api/component/age-label/age-label.module';
import {EmailModule} from '../../../../../../components/common/email/email.module';
import {PhoneLabelModule} from '../../../../../common/phone/component/phone-label/phone-label.module';
import {SummaryModule} from "../../../../../core/component/summary/summary.module";
import {CardModule} from "../../../../../core/component/card/card.module";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {
    ConfirmationButtonModule
} from "../../../../../../components/common/button/confirmation-button/confirmation-button.module";
@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        ActionDefaultModule,
        LoadingModule,
        ErrorTextModule,
        ItemModule,
        SummaryFieldModule,
        LovValueSummaryFieldModule,
        MatTooltipModule,
        AdditionalPropertyLabelModule,
        AgeLabelModule,
        EmailModule,
        PhoneLabelModule,
        SummaryModule,
        CardModule,
        ButtonModule,
        ConfirmationButtonModule,
    ],
    declarations: [
        PartnerSimilarPartnerViewDialogComponent,
    ],
    exports: [
        PartnerSimilarPartnerViewDialogComponent
    ],
})
export class PartnerSimilarPartnerViewDialogModule{}
